// mobile.de hard limit per https://services.mobile.de/manual/changelog.html (T20-123039 US 2 AC #3).
export const HIGHLIGHT_MAX_LENGTH = 22;
